export function tryDecreaseDepth(dragItem) {
  const { childrenProp, collapsed } = this.props;
  const pathFrom = this.getPathById(dragItem.id);
  const itemIndex = pathFrom[pathFrom.length - 1];
  // has parent
  if (pathFrom.length > 1) {
    const parent = this.getItemByPath(pathFrom.slice(0, -1));
    // is last (by order) item in array
    if (itemIndex + 1 === parent[childrenProp].length) {
      const pathTo = pathFrom.slice(0, -1);
      pathTo[pathTo.length - 1] += 1;
      // if collapsed by default and is last (by count) item in array remove this node from list of open nodes
      let collapseProps = {};
      if (collapsed && parent[childrenProp].length === 1) {
        collapseProps = this.onToggleCollapse(parent, true);
      }

      this.moveItem({ dragItem, pathFrom, pathTo }, collapseProps);
    }
  }
}
